import React, { memo, useContext, useMemo } from 'react'
import { Card, ScreenContext, ResponsiveImage, mobileBreakpoint } from 'react-components'
import { ThemeContext } from 'styled-components'

import { MultiSizedImageTransport, TestimonialTransport } from '@common/transports/deprecated-home-page-transport'
import {
    ImageContainer,
    CardContainer,
    CardContent,
    ContentContainer,
    DescriptionText,
    DesignationText,
    GreetingIcon,
    NameText,
    TestimonialImage,
    QuotationMarkContent,
} from './testimonials-styles'

type Props = {
    testimonial: TestimonialTransport
}

const _getSources = (image: MultiSizedImageTransport) => [
    { srcSet: image.url.medium, media: `(min-width: 560px) and (max-width: ${mobileBreakpoint.max}px)` },
]

const TestimonialCard: React.FC<Props> = ({ testimonial }) => {
    const theme = useContext(ThemeContext)
    const { isDesktop } = useContext(ScreenContext)
    const _sources = useMemo(() => _getSources(testimonial.image), [testimonial.image])
    return (
        <CardContainer>
            <Card
                shadowed
                borderRadius={theme.typography.border.radius.small}
                backgroundColor="transparent"
                boxShadow={isDesktop ? '0' : `0 ${theme.spacing.xxxSmall} ${theme.spacing.small} 0 #00000026`}
            >
                <CardContent>
                    <ImageContainer>
                        <ResponsiveImage
                            src={testimonial.image.url.small}
                            alt={testimonial.image.alt}
                            sources={_sources}
                            as={TestimonialImage}
                        />
                    </ImageContainer>
                    <ContentContainer>
                        <QuotationMarkContent>
                            <GreetingIcon />
                        </QuotationMarkContent>
                        <div>
                            <DescriptionText>{testimonial.reviewText}</DescriptionText>
                            <NameText>{testimonial.givenBy}</NameText>
                            <DesignationText
                                href={testimonial.listing.url}
                                target={testimonial.listing.target || '_self'}
                            >
                                {testimonial.listing.text}
                            </DesignationText>
                        </div>
                    </ContentContainer>
                </CardContent>
            </Card>
        </CardContainer>
    )
}

export default memo(TestimonialCard)
